import React from "react";
import Navbar from "../components/main_page/Navbar";
import Cover from "../components/portfolio/Cover";
import displayvid1 from "../assets/images/portfolio/PNT-Clothing/index.mp4";
import displayvid2 from "../assets/images/portfolio/strath-booking/index.mp4";
import displayvid3 from "../assets/images/portfolio/esoma/index.m4v";
import displayvid4 from "../assets/images/portfolio/discord-feud/index.m4v";
import displayvid5 from "../assets/images/portfolio/two-of-us/index.m4v";

function Portfolio() {
  return (
    <div className="pb-40">
      <Navbar focus="portfolio" />

      <div>
        <h1 className="font-bold text-cool-400 text-6xl text-center mt-40">
          My work
        </h1>
      </div>
      <div className="mt-40 xl:px-40 px-10 flex justify-around gap-y-20 flex-wrap">
        <Cover
          thumbnail={displayvid1}
          title="PNT Store"
          url="pnt-store"
          description="Online e-commerce shop"
        />

        <Cover
          thumbnail={displayvid2}
          title="SDS"
          url="sds"
          description="Web based disciplinary system for Strathmore School"
        />

        <Cover
          thumbnail={displayvid3}
          title="Esoma"
          url="esoma"
          description="Online educational service"
        />

        <Cover
          thumbnail={displayvid4}
          title="Discord Feud"
          url="discord-feud"
          description="Family Feud Discord bot"
        />

        <Cover
          thumbnail={displayvid5}
          title="Two of these People are Lying"
          url="two-of-these-people"
          description="Online Parlour Game"
        />
      </div>
    </div>
  );
}

export default Portfolio;
